import { useEffect, useRef, useState } from 'react';
import { Utilities } from '../../MedicareProAPI/Utilities/Utilities';
import { Twilio } from '../Components/IntegrationManagers/Twilio';
import StyledModal from '../Components/StyledModal';


export default function IntegrationSingle({
  service,
  userId,
  agencyId,
  userAccessToken,
  renderedExternal = false,
}) {
  const [loading, setLoading] = useState(true);

  const [integrationSelectedAccount, setIntegrationSelectedAccount] = useState(null);
  const [integrationCreating, setIntegrationCreating] = useState(false);

  const [integrationAccounts, setIntegrationAccounts] = useState(null);
  const [integrationExtensionsLoading, setIntegrationExtensionsLoading] = useState(false);
  const [integrationExtensionsSaving, setIntegrationExtensionsSaving] = useState(false);
  const [integrationExtensionsSelected, setIntegrationExtensionsSelected] = useState([]);
  const [integrationExtensions, setIntegrationExtensions] = useState(null);
  const [integrationPhoneNumbersLoading, setIntegrationPhoneNumbersLoading] = useState(false);
  const [integrationPhoneNumbersSaving, setIntegrationPhoneNumbersSaving] = useState(false);
  const [integrationPhoneNumbers, setIntegrationPhoneNumbers] = useState(null);
  const [integrationPhoneNumbersSelected, setIntegrationPhoneNumbersSelected] = useState([]);
  const [integrationSyncIteration, setIntegrationSyncIteration] = useState(null);
  const [integrationSyncAvailable, setIntegrationSyncAvailable] = useState(null);
  const [integrationSyncTotal, setIntegrationSyncTotal] = useState(null);
  const [integrationSyncErrors, setIntegrationSyncErrors] = useState(null);
  const [integrationSyncInds, setIntegrationSyncInds] = useState(null);
  const [integrationSyncStep1Loading, setIntegrationSyncStep1Loading] = useState(false);
  const [integrationSyncStep2Loading, setIntegrationSyncStep2Loading] = useState(false);
  const [integrationSyncStep3Loading, setIntegrationSyncStep3Loading] = useState(false);
  const [integrationSyncComplete, setIntegrationSyncComplete] = useState(false);
  const [integrationSyncExtensions, setIntegrationSyncExtensions] = useState(false);
  const [integrationSyncExtensionSelected, setIntegrationSyncExtensionSelected] = useState([]);
  const [integrationSyncGroups, setIntegrationSyncGroups] = useState(false);
  const [integrationSyncGroupSelected, setIntegrationSyncGroupSelected] = useState([]);
  const [integrationSyncDisabled, setIntegrationSyncDisabled] = useState(true);

  const [integrationAppWebhooksModal, setIntegrationAppWebhooksModal] = useState(false);
  const [integrationAppWebhooksSaving, setIntegrationAppWebhooksSaving] = useState(false);
  const [integrationAppWebhooksDeleting, setIntegrationAppWebhooksDeleting] = useState(null);
  const [integrationAppWebhookNewForm, setIntegrationAppWebhookNewForm] = useState([]);
  const [integrationAppWebhookData, setIntegrationAppWebhookData] = useState(null);

  const [personalAccessTokenExists, setPersonalAccessTokenExists] = useState(null);
  const [personalAccessTokenNew, setPersonalAccessTokenNew] = useState(null);
  const [personalAccessTokenCreateModal, setPersonalAccessTokenCreateModal] = useState(false);
  const [personalAccessTokenCreateLoading, setPersonalAccessTokenCreateLoading] = useState(false);
  const [personalAccessTokenEditModal, setPersonalAccessTokenEditModal] = useState(false);
  const [personalAccessTokenRevokeLoading, setPersonalAccessTokenRevokeLoading] = useState(false);
  const [personalAccessTokenRevoked, setPersonalAccessTokenRevoked] = useState(false);

  const [externalOauthAppExists, setExternalOauthAppExists] = useState(false);

  const [externalPersonalAccessTokenExists, setExternalPersonalAccessTokenExists] = useState(false);
  const [externalPersonalAccessToken, setExternalPersonalAccessToken] = useState(null);
  const [externalPersonalAccessAccountId, setExternalPersonalAccessAccountId] = useState(null);
  const [externalPersonalAccessUsername, setExternalPersonalAccessUsername] = useState(null);
  const [externalPersonalAccessPassword, setExternalPersonalAccessPassword] = useState(null);
  const [externalPersonalAccessTokenCreateModal, setExternalPersonalAccessTokenCreateModal] =
    useState(false);
  const [externalPersonalAccessTokenEditModal, setExternalPersonalAccessTokenEditModal] =
    useState(false);
  const [externalPersonalAccessTokenSaving, setExternalPersonalAccessTokenSaving] = useState(false);
  const [externalPersonalAccessTokenRevokeLoading, setExternalPersonalAccessTokenRevokeLoading] =
    useState(false);
  const [externalPersonalAccessTokenRevoked, setExternalPersonalAccessTokenRevoked] =
    useState(false);

  const [externalUsernamePasswordExists, setExternalUsernamePasswordExists] = useState(false);
  const [externalUsernamePasswordUsername, setExternalUsernamePasswordUsername] = useState(null);
  const [externalUsernamePasswordPass, setExternalUsernamePasswordPass] = useState(null);
  const [externalUsernamePasswordAccessToken, setExternalUsernamePasswordAccessToken] =
    useState(null);
  const [externalUsernamePasswordCreateModal, setExternalUsernamePasswordCreateModal] =
    useState(false);
  const [externalUsernamePasswordEditModal, setExternalUsernamePasswordEditModal] = useState(false);
  const [externalUsernamePasswordSaving, setExternalUsernamePasswordSaving] = useState(false);
  const [externalUsernamePasswordRevokeLoading, setExternalUsernamePasswordRevokeLoading] =
    useState(false);
  const [externalUsernamePasswordRevoked, setExternalUsernamePasswordRevoked] = useState(false);

  const [agencyIntegrationPat, setAgencyIntegrationPat] = useState(null);
  const [agencyIntegrationPatExists, setAgencyIntegrationPatExists] = useState(false);

  const [externalUsernameExists, setExternalUsernameExists] = useState(false);
  const [externalUsernameUsername, setExternalUsernameUsername] = useState(null);
  const [externalUsernameAccessToken, setExternalUsernameAccessToken] = useState(null);
  const [externalUsernameCreateModal, setExternalUsernameCreateModal] = useState(false);
  const [externalUsernameEditModal, setExternalUsernameEditModal] = useState(false);
  const [externalUsernameSaving, setExternalUsernameSaving] = useState(false);
  const [externalUsernameRevokeLoading, setExternalUsernameRevokeLoading] = useState(false);
  const [externalUsernameRevoked, setExternalUsernameRevoked] = useState(false);

  const [userIntegrationOAuthExists, setUserIntegrationOAuthExists] = useState(null);
  const [userIntegrationOAuth, setUserIntegrationOAuth] = useState(null);
  const [userIntegrationOAuthError, setUserIntegrationOAuthError] = useState(null);
  const [userIntegrationOAuthPayload, setUserIntegrationOAuthPayload] = useState(null);
  const [agencyIntegrationOAuthExists, setAgencyIntegrationOAuthExists] = useState(null);
  const [agencyIntegrationOAuth, setAgencyIntegrationOAuth] = useState(null);

  const [agencyIntegrationOAuthLoading, setAgencyIntegrationOAuthLoading] = useState(false);
  const [userIntegrationOAuthDisconnectLoading, setUserIntegrationOAuthDisconnectLoading] =
    useState(false);

  const [agencyIntegrationOAuthModal, setAgencyIntegrationOAuthModal] = useState(false);
  const [integrationAccountModal, setIntegrationAccountModal] = useState(false);

  const [integrationExtensionNumberModal, setIntegrationExtensionNumberModal] = useState(false);
  const [integrationSyncModal, setIntegrationSyncModal] = useState(false);

  const userMarxWebhookUrl =
    'https://service.medicareproapp.com/webhooks/marx?service=medizues&accessToken=' +
    userAccessToken;

  const [thisServiceWebhookUrl, setThisServiceWebhookUrl] = useState(null);

  const userWebhookUrlTextAreaRef = useRef(null);
  const [userWebhookUrlCopied, setUserWebhookUrlCopied] = useState(false);

  const [syncProfileTypeSelected, setSyncProfileTypeSelected] = useState('Active Client');
  const profileSyncTypeOptions = ['Active Client', 'Prospect', 'All'];

  const [simpleTextingPhoneNumber, setSimpleTextingPhoneNumber] = useState(null);

  const [appAccounts, setAppAccounts] = useState([]);
  const [singleOverwrite, setSingleOverwrite] = useState(false);

  //const accountIdRequired = ['textrequest', 'healthsherpamedicare'];
  const accountIdRequired = [];
  const needsAccountId = accountIdRequired.includes(service.id);
  const showSave = !needsAccountId || !!externalPersonalAccessAccountId;

  var webAPI = new MedicareProAPI.WebAPI();
  webAPI.setAccessToken(userAccessToken);

  var userRepository = new MedicareProAPI.UserRepository();
  userRepository.setAccessToken(userAccessToken);

  var userIntegrationOAuthRepository = new MedicareProAPI.UserIntegrationOAuthRepository();
  userIntegrationOAuthRepository.setAccessToken(userAccessToken);

  var agencyIntegrationOAuthRepository = new MedicareProAPI.AgencyIntegrationOAuthRepository();
  agencyIntegrationOAuthRepository.setAccessToken(userAccessToken);

  var userPersonalTokenRepository = new MedicareProAPI.UserPersonalTokenRepository();
  userPersonalTokenRepository.setAccessToken(userAccessToken);

  var userVoipExtensionRepository = new MedicareProAPI.UserVoipExtensionRepository();
  userVoipExtensionRepository.setAccessToken(userAccessToken);

  var userVoipPhoneNumberRepository = new MedicareProAPI.UserVoipPhoneNumberRepository();
  userVoipPhoneNumberRepository.setAccessToken(userAccessToken);

  var individualRepository = new MedicareProAPI.IndRepository();
  individualRepository.setAccessToken(userAccessToken);

  var individualAlternateIdRepository = new MedicareProAPI.IndAlternateIdRepository();
  individualAlternateIdRepository.setAccessToken(userAccessToken);

  var userAppWebhookRepository = new MedicareProAPI.UserAppWebhookRepository();
  userAppWebhookRepository.setAccessToken(userAccessToken);

  var userTokenRepository = new MedicareProAPI.UserTokenRepository();
  userTokenRepository.setAccessToken(userAccessToken);

  var agencyPersonalTokenRepository = new MedicareProAPI.AgencyPersonalTokenRepository();
  agencyPersonalTokenRepository.setAccessToken(userAccessToken);

  const handleWebhookUrlCopy = (e) => {
    userWebhookUrlTextAreaRef.current.select();
    document.execCommand('copy');
    //e.target.focus();
    setUserWebhookUrlCopied(true);
  };

  const handleAccountSave = (parameters) => {
    return userIntegrationOAuthRepository.putUserIntegrationOAuth(
      userId,
      service.id,
      { include: ['identifier', 'accountId'] },
      parameters
    );
  };

  const handleIntegrationAppWebhookAddClick = (event) => {
    setIntegrationAppWebhooksModal(true);
  };

  const handleIntegrationAppWebhookSave = (event) => {
    setIntegrationAppWebhooksSaving(true);

    userAppWebhookRepository
      .createUserAppWebhook(service.id, integrationAppWebhookNewForm)
      .then((response) => {
        setIntegrationAppWebhooksSaving(false);
        setIntegrationAppWebhooksModal(false);

        if (response.getId()) {
          let _integrationAppWebhookData = [...integrationAppWebhookData];
          _integrationAppWebhookData.push(response);

          setIntegrationAppWebhookData(_integrationAppWebhookData);
        }
      });
  };

  const handleIntegrationAppWebhookFormDataChange = (event) => {
    const target = event.target;

    let updatedAppWebhookFormData = { ...integrationAppWebhookNewForm };

    updatedAppWebhookFormData[target.name] = target.value;

    setIntegrationAppWebhookNewForm(updatedAppWebhookFormData);
  };

  const handleIntegrationAppWebhookDeleteClick = (appWebhookIndex) => {
    let selectedAppWebhook = integrationAppWebhookData[appWebhookIndex];
    let updatedAppWebhookFormData = [...integrationAppWebhookData];

    updatedAppWebhookFormData.splice(appWebhookIndex, 1);

    if (selectedAppWebhook.id) {
      setIntegrationAppWebhooksDeleting(selectedAppWebhook.id);
      userAppWebhookRepository.deleteUserAppWebhook(selectedAppWebhook.id).then((response) => {
        setIntegrationAppWebhookData(updatedAppWebhookFormData);
        setIntegrationAppWebhooksDeleting(null);
      });
    }
  };

  const handlePersonalAccessTokenCreateClick = (event) => {
    setPersonalAccessTokenCreateModal(true);
    setPersonalAccessTokenCreateLoading(true);
    setPersonalAccessTokenEditModal(false);

    userPersonalTokenRepository
      .createUserPersonalToken(userId, service.id, { name: service.name })
      .then((personalAccessToken) => {
        setPersonalAccessTokenNew(personalAccessToken);
        setPersonalAccessTokenCreateLoading(false);
        setPersonalAccessTokenExists(true);

        if (service.generateIncomingWebhookUrlOnSetup) {
          setThisServiceWebhookUrl(
            'https://www.medicareproapp.com/api/v1/webhooks/' +
            service.id +
            '?accessToken=' +
            personalAccessToken.getAccessToken()
          );
        }
      });
  };

  const handlePersonalAccessTokenEditClick = (event) => {
    setPersonalAccessTokenEditModal(true);
  };

  const handlePersonalAccessTokenRevokeClick = (event) => {
    setPersonalAccessTokenRevokeLoading(true);

    userPersonalTokenRepository.deleteUserPersonalToken(userId, service.id).then((response) => {
      setPersonalAccessTokenRevokeLoading(false);
      setPersonalAccessTokenExists(false);
      setPersonalAccessTokenRevoked(true);
    });
  };

  const handleExternalPersonalAccessTokenCreateClick = (event) => {
    setExternalPersonalAccessTokenCreateModal(true);
    setExternalPersonalAccessTokenEditModal(false);
  };

  const fetchAppAccounts = (token) => {
    webAPI.getUserIntegrationExternalAccounts(service.id, token).then((response) => {
      console.log(response);
      setAppAccounts(response);
    });
  };

  const handleExternalUsernamePasswordCreateClick = (event) => {
    setExternalUsernamePasswordCreateModal(true);
    setExternalUsernamePasswordEditModal(false);
  };

  const handleExternalPersonalAccessTokenEditClick = (event) => {
    setExternalPersonalAccessTokenEditModal(true);
  };

  const handleExternalUsernamePasswordEditClick = (event) => {
    setExternalUsernamePasswordEditModal(true);
  };

  const handleExternalUsernameEditClick = (event) => {
    setExternalUsernameEditModal(true);
  };

  const handleExternalUsernameCreateClick = (event) => {
    setExternalUsernameCreateModal(true);
    setExternalUsernameEditModal(false);
  };

  const handleExternalPersonalAccessTokenSave = (event) => {
    setExternalPersonalAccessTokenSaving(true);
    let payload = { name: service.name, external: true };

    if (externalPersonalAccessToken) {
      payload['personalAccessToken'] = externalPersonalAccessToken;
    }
    if (externalPersonalAccessAccountId) {
      payload['accountId'] = externalPersonalAccessAccountId;
    }
    if (externalPersonalAccessUsername) {
      payload['username'] = externalPersonalAccessUsername;
      if (service.id === 'healthsherpamedicare') {
        payload['username'] = payload['username'].toLowerCase();
      }
    }
    if (externalPersonalAccessPassword) {
      payload['password'] = externalPersonalAccessPassword;
    }
    if (agencyIntegrationPatExists && !singleOverwrite) {
      payload['agencyPersonalAccessToken'] = agencyIntegrationPat.id;
    }

    if (
      service.id === 'healthsherpamedicare' &&
      !externalPersonalAccessToken &&
      !agencyIntegrationPatExists
    ) {
      alert(
        'Your agency has not set up the Health Sherpa Medicare Integration from their agency platform yet. This can be accomplished from the agency settings page under "Enrollment"'
      );
      return;
    }

    userPersonalTokenRepository
      .createUserPersonalToken(userId, service.id, payload)
      .then((personalAccessToken) => {
        setExternalPersonalAccessTokenSaving(false);
        setExternalPersonalAccessTokenExists(true);
        setExternalPersonalAccessToken(null);
        setExternalPersonalAccessTokenCreateModal(false);

        // Register sms webhook for some vendors ['simpletexting','openphone', 'textrequest']
        if (
          service.id === 'simpletexting' ||
          service.id === 'openphone' ||
          service.id === 'textrequest'
        ) {
          webAPI
            .subscribeUserVoipWebhooks(
              service.id,
              { phoneNumber: simpleTextingPhoneNumber },
              service.type
            )
            .catch((error) => {
              userPersonalTokenRepository.deleteUserPersonalToken(userId, service.id);
              setExternalPersonalAccessTokenExists(false);
              alert(`Failed to subscribe webhooks for ${service.id}: ${error.message}`);
            });
        }
      });
  };

  const handleExternalUsernamePasswordSave = (event) => {
    setExternalUsernamePasswordSaving(true);
    userPersonalTokenRepository
      .createUserPersonalToken(userId, service.id, {
        name: service.name,
        external: true,
        username: externalUsernamePasswordUsername,
        password: externalUsernamePasswordPass,
        personalAccessToken: externalUsernamePasswordAccessToken,
      })
      .then((personalAccessToken) => {
        setExternalUsernamePasswordSaving(false);
        setExternalUsernamePasswordExists(true);
        setExternalUsernamePassword(null);
        setExternalUsernamePasswordCreateModal(false);
      });
  };

  const handleExternalPersonalAccessTokenNew = (event) => {
    setExternalPersonalAccessToken(event.target.value);

    if (service.id == 'textrequest') {
      fetchAppAccounts(event.target.value);
    }
  };

  const handleExternalUsernamePasswordUsernameNew = (event) => {
    setExternalUsernamePasswordUsername(event.target.value);
  };

  const handleExternalUsernamePasswordPassNew = (event) => {
    setExternalUsernamePasswordPass(event.target.value);
  };

  const handleExternalUsernamePasswordAccessTokenNew = (event) => {
    setExternalUsernamePasswordAccessToken(event.target.value);
  };

  const handleExternalPersonalAccessTokenRevokeClick = async (event) => {
    setExternalPersonalAccessTokenRevokeLoading(true);

    try {
      // 1. Unsubscribe from webhooks first, if needed
      if (
        service.id === 'simpletexting' ||
        service.id === 'openphone' ||
        service.id === 'textrequest'
      ) {
        try {
          await webAPI.unsubscribeUserVoipWebhooks(service.id, service.type);
        } catch (error) {
          alert(`Failed to unsubscribe webhooks for ${service.id}:`, error.message);
          return;
          // Optionally show a user-friendly error or rethrow if needed
        }
      }

      // 2. Then delete the personal token
      await userPersonalTokenRepository.deleteUserPersonalToken(userId, service.id);

      // 3. Update state
      setExternalPersonalAccessTokenExists(false);
      setExternalPersonalAccessTokenRevoked(true);
    } catch (error) {
      console.error('Error revoking token:', error);
      // Handle errors as needed
    } finally {
      setExternalPersonalAccessTokenRevokeLoading(false);
    }
  };

  const handleExternalUsernamePasswordRevokeClick = (event) => {
    setExternalUsernamePasswordRevokeLoading(true);

    userPersonalTokenRepository.deleteUserPersonalToken(userId, service.id).then((response) => {
      setExternalUsernamePasswordRevokeLoading(false);
      setExternalUsernamePasswordExists(false);
      setExternalUsernamePasswordRevoked(true);
    });
  };

  const handleExternalUsernameUsernameNew = (event) => {
    setExternalUsernameUsername(event.target.value);
  };

  const handleExternalUsernameSave = (event) => {
    setExternalUsernameSaving(true);
    userPersonalTokenRepository
      .createUserPersonalToken(userId, service.id, {
        name: service.name,
        external: true,
        username: externalUsernameUsername,
        password: externalUsernamePass,
        personalAccessToken: externalUsernameAccessToken,
      })
      .then((personalAccessToken) => {
        setExternalUsernameSaving(false);
        setExternalUsernameExists(true);
        setExternalUsername(null);
        setExternalUsernameCreateModal(false);
      });
  };

  const handleExternalUsernameRevokeClick = (event) => {
    setExternalUsernameRevokeLoading(true);

    userPersonalTokenRepository.deleteUserPersonalToken(userId, service.id).then((response) => {
      setExternalUsernameRevokeLoading(false);
      setExternalUsernameExists(false);
      setExternalUsernameRevoked(true);
    });
  };

  useEffect(() => {
    if (integrationSyncIteration) {
      let limit = 5;
      let chunkItem = integrationSyncIteration - 1;
      let filteredIndsChunks = integrationSyncInds.chunk(limit);
      let rounds = filteredIndsChunks.length;
      console.log('profile type to sync:', syncProfileTypeSelected);
      let individualsPayload = [];
      if (syncProfileTypeSelected !== 'All') {
        individualsPayload = filteredIndsChunks[chunkItem].filter((item) => {
          return item.getIndStatus() === syncProfileTypeSelected;
        });
      } else {
        individualsPayload = filteredIndsChunks[chunkItem];
      }

      let payload = {
        individuals: individualsPayload,
        extension: integrationSyncExtensionSelected,
        accountId: integrationSelectedAccount,
      };

      if (integrationSyncGroupSelected != '') {
        payload['group'] = integrationSyncGroupSelected;
      }

      setIntegrationSyncErrors(null);

      // Send contacts to provider
      webAPI
        .addUserIntegrationOAuthContacts(userId, service.id, payload)
        .then((indAlternateIds) => {
          // Save returned contact ids from provider
          let errors = [];

          if (indAlternateIds) {
            indAlternateIds.forEach((responseSingle) => {
              if (responseSingle.error) {
                errors.push(responseSingle);
              }
            });
          }

          if (errors.length > 0) {
            setIntegrationSyncErrors(errors);
          }

          individualAlternateIdRepository
            .addIndAlternateIds(userId, indAlternateIds)
            .then((response) => {
              setIntegrationSyncTotal(integrationSyncTotal + limit);

              let integrationSyncIterationNew = integrationSyncIteration + 1;

              if (integrationSyncIterationNew <= rounds) {
                setTimeout(function () {
                  setIntegrationSyncIteration(integrationSyncIterationNew);
                }, 5000);
              } else {
                setIntegrationSyncComplete(true);
                setIntegrationSyncIteration(null);

                setTimeout(function () {
                  setIntegrationSyncComplete(false);
                  setIntegrationSyncStep3Loading(false);
                  setIntegrationExtensionsSelected(null);
                  setIntegrationSyncTotal(null);
                  setIntegrationSyncAvailable(null);
                  setIntegrationSyncInds(null);
                  setIntegrationSyncModal(false);
                }, 5000);
              }
            });
        });
    }
  }, [integrationSyncIteration]);

  const handleSyncProfileTypeChange = (event) => {
    setSyncProfileTypeSelected(event.target.value);
  };

  const handleStartSyncClick = (event) => {
    setIntegrationSyncStep3Loading(true);
    setIntegrationSyncIteration(1);
    setIntegrationSyncDisabled(true);
  };

  const toggleIntegrationSyncExtension = (extensionId) => {
    setIntegrationSyncExtensionSelected(extensionId);
    getUserExtensionGroups(extensionId);
  };

  const toggleIntegrationSyncGroup = (event) => {
    setIntegrationSyncGroupSelected(event.target.value);
  };

  const getUserExtensionGroups = (extensionId) => {
    console.log(userIntegrationOAuth);
    webAPI
      .getUserIntegrationOAuthVoipGroupsByExtension(
        userId,
        'phonecom',
        userIntegrationOAuth.accountId,
        extensionId
      )
      .then((response) => {
        setIntegrationSyncGroups(response);
      });
  };

  const toggleIntegrationExtension = (extensionId) => {
    let integrationExtensionsSelectedNew = [...integrationExtensionsSelected];

    if (integrationExtensionsSelectedNew.includes(extensionId)) {
      let existingIndex = integrationExtensionsSelectedNew.indexOf(extensionId);
      integrationExtensionsSelectedNew.splice(existingIndex, 1);
    } else {
      integrationExtensionsSelectedNew.push(extensionId);
    }

    setIntegrationExtensionsSelected(integrationExtensionsSelectedNew);
  };

  const toggleIntegrationPhoneNumber = (phoneNumberId) => {
    let integrationPhoneNumbersSelectedNew = [...integrationPhoneNumbersSelected];

    if (integrationPhoneNumbersSelectedNew.includes(phoneNumberId)) {
      let existingIndex = integrationPhoneNumbersSelectedNew.indexOf(phoneNumberId);
      integrationPhoneNumbersSelectedNew.splice(existingIndex, 1);
    } else {
      integrationPhoneNumbersSelectedNew.push(phoneNumberId);
    }

    setIntegrationPhoneNumbersSelected(integrationPhoneNumbersSelectedNew);
  };

  const handleIntegrationExtensionsSave = (event) => {
    setIntegrationExtensionsSaving(true);

    webAPI.deleteUserVoipExtensions(userId, service.databaseId).then((deleteResponse) => {
      console.log('Selected:', integrationExtensionsSelected);
      console.log('list: ', integrationExtensions);
      integrationExtensionsSelected.forEach((extensionId) => {
        console.log('saving extension: ', extensionId);
        let extensionData = integrationExtensions.find(
          (extension) => String(extension.extensionId) == extensionId
        );
        console.log('found extension: ', extensionData);
        let payload = {
          extensionId: extensionData.extensionId,
          extensionName: extensionData.extensionName,
          extensionNumber: extensionData.extensionNumber,
          provider: extensionData.provider,
        };

        userVoipExtensionRepository.createUserVoipExtensions(userId, payload).then((response) => {
          setIntegrationExtensionsSaving(false);
        });
      });
    });
  };

  const handleIntegrationPhoneNumbersSave = (event) => {
    setIntegrationPhoneNumbersSaving(true);

    webAPI.deleteUserVoipPhoneNumbers(userId, service.databaseId).then((deleteResponse) => {
      console.log('phone numbers selected: ', integrationPhoneNumbersSelected);
      integrationPhoneNumbersSelected.forEach((phoneNumberId) => {
        let phoneNumberData = integrationPhoneNumbers.find(
          (phoneNumber) => String(phoneNumber.phoneNumberId) === phoneNumberId
        );
        console.log('found phone number: ', phoneNumberData);
        let payload = {
          phoneNumberId: phoneNumberData.phoneNumberId,
          phoneNumberName: phoneNumberData.phoneNumberName,
          phoneNumber: phoneNumberData.phoneNumber,
          provider: phoneNumberData.provider,
        };

        userVoipPhoneNumberRepository
          .createUserVoipPhoneNumbers(userId, payload)
          .then((response) => { });
      });

      setIntegrationPhoneNumbersSaving(false);
      setIntegrationExtensionNumberModal(false);
    });
  };

  const handleOAuthUserSyncClick = (event) => {
    if (service.id == 'dialpad') {
      handleOAuthDialpadUserSyncClick(event);
    } else if (service.id == 'phonecom') {
      handleOAuthPhonecomUserSyncClick(event);
    }
  };

  const handleOAuthPhonecomUserSyncClick = async (event) => {
    setIntegrationSyncModal(true);

    // If we already loaded them, don't refetch
    if (integrationSyncInds) return;

    setIntegrationSyncStep1Loading(true);

    const PAGE_SIZE = 500; // tune: 250–1000
    const criteria = { ownerId: userId, indStatus: ['Active Client', 'Prospect'] };

    let offset = 0;
    const all = [];

    try {
      // ── 1) Page through individuals
      while (true) {
        const page = await individualRepository.getInds({
          limit: PAGE_SIZE,
          offset,
          order: 'ASC',
          sortBy: 'indLastname',
          criteria,
          include: ['addresses', 'emails', 'phones', 'alternateIds', 'spouse'],
        });

        const items = (page && page.getItems && page.getItems()) || [];
        all.push(...items);

        if (items.length < PAGE_SIZE) break; // last page
        offset += PAGE_SIZE;
      }

      // ── 2) Filter out individuals that already have an alternateId for this provider
      const filtered = all.filter((individual) => {
        const alts = (individual.getAlternateIds && individual.getAlternateIds().getItems()) || [];
        return (
          alts.filter((alt) => {
            const prov = alt.getProvider && alt.getProvider();
            return prov && prov.getReference && prov.getReference() === service.id;
          }).length === 0
        );
      });

      // ── 3) Enrich from spouse when missing data
      filtered.forEach((individual) => {
        const spouse = individual.getSpouse && individual.getSpouse();
        if (!spouse) return;

        // addresses
        const indAddrs = (individual.getAddresses && individual.getAddresses().getItems()) || [];
        const spAddrs = (spouse.getAddresses && spouse.getAddresses().getItems()) || [];
        if (indAddrs.length === 0 && spAddrs.length > 0) {
          individual.addresses['items'] = spAddrs;
        }

        // phones (copy spouse "Home" phones only)
        const indPhones = (individual.getPhones && individual.getPhones().getItems()) || [];
        const spPhones = (spouse.getPhones && spouse.getPhones().getItems()) || [];
        if (indPhones.length === 0 && spPhones.length > 0) {
          const homePhones = spPhones.filter(
            (p) => p.getIndPhoneType && p.getIndPhoneType() === 'Home'
          );
          individual.phones['items'] = homePhones.slice();
        }
      });

      setIntegrationSyncStep1Loading(false);
      setIntegrationSyncAvailable(filtered.length);
      setIntegrationSyncInds(filtered);

      // ── 4) Load extensions if there’s something to sync
      if (filtered.length > 0) {
        setIntegrationSyncStep2Loading(true);
        const extensions = await userVoipExtensionRepository.getUserVoipExtensions(
          userId,
          service.databaseId
        );
        setIntegrationSyncStep2Loading(false);
        setIntegrationSyncExtensions(extensions);
      }
    } catch (e) {
      console.error(e);
      setIntegrationSyncStep1Loading(false);
    }
  };

  const handleOAuthDialpadUserSyncClick = (event) => {
    setIntegrationSyncModal(true);

    if (!integrationSyncInds) {
      setIntegrationSyncStep1Loading(true);

      let criteria = { ownerId: userId, indStatus: ['Active Client', 'Prospect'] };

      individualRepository
        .getInds({
          limit: 4000,
          offset: 0,
          order: 'ASC',
          sortBy: 'indLastname',
          criteria: criteria,
          include: ['addresses', 'emails', 'phones', 'alternateIds', 'spouse'],
        })
        .then((individuals) => {
          // Only sync ind if no contactId exists for this provider
          let filteredInds = individuals.getItems().filter((individual) => {
            return (
              individual
                .getAlternateIds()
                .getItems()
                .filter((alternate) => {
                  return alternate.getProvider().getReference() === service.id;
                }).length == 0
            );
          });

          setIntegrationSyncStep1Loading(false);
          setIntegrationSyncAvailable(filteredInds.length);
          setIntegrationSyncInds(filteredInds);

          if (filteredInds.length > 0) {
            filteredInds.forEach((individual) => {
              var spouse = individual.getSpouse();

              if (spouse) {
                if (individual.getAddresses().getItems().length == 0) {
                  if (spouse.getAddresses().getItems().length > 0) {
                    individual.addresses['items'] = spouse.addresses['items'];
                  }
                }

                if (individual.getPhones().getItems().length == 0) {
                  if (spouse.getPhones().getItems().length > 0) {
                    var phoneCount = 0;
                    spouse
                      .getPhones()
                      .getItems()
                      .forEach((phone) => {
                        if (phone.getIndPhoneType() == 'Home') {
                          individual.phones['items'][phoneCount] = phone;
                          phoneCount++;
                        }
                      });
                  }
                }
              }
            });

            setIntegrationSyncStep2Loading(false);
            setIntegrationSyncDisabled(false);

            /* userVoipExtensionRepository.getUserVoipExtensions(userId, service.databaseId).then(extensions => {
                            setIntegrationSyncStep2Loading(false);

                            setIntegrationSyncExtensions(extensions);
                        }); */
          }
        });
    }
  };

  const handleAccountSaveClick = (event) => {
    setIntegrationCreating(true);
    console.log('selected account: ', integrationSelectedAccount);
    console.log(integrationAccounts);
    const selectedAcount = integrationAccounts.find(
      (integrationAccount) => integrationAccount.phoneNumberId == integrationSelectedAccount
    );

    var accId = selectedAcount.id || selectedAcount.phoneNumberId;

    if (!accId) {
      agencyIntegrationOAuth.accountId;
    }

    var parameters = {
      accountId: accId,
      identifier: selectedAcount.identifier || selectedAcount.phoneNumber,
      payload: userIntegrationOAuthPayload,
    };

    if (agencyIntegrationOAuth) {
      parameters.agencyIntegrationOauth = agencyIntegrationOAuth.id;
    }

    handleAccountSave(parameters).then((oauthResponse) => {
      setIntegrationCreating(false);
      setIntegrationAccountModal(false);
      setUserIntegrationOAuth(oauthResponse);
      setUserIntegrationOAuthExists(true);

      if (service.syncContacts === true) {
        phoneNumberSelection(service.id, agencyIntegrationOAuth.accountId);
      }
    });
  };

  const handleOAuthUserDisconnectClick = (event) => {
    setUserIntegrationOAuthDisconnectLoading(true);

    webAPI.disconnectUserIntegrationOAuth(service.id).then((response) => {
      setUserIntegrationOAuthExists(false);
      setUserIntegrationOAuth(null);
      setUserIntegrationOAuthDisconnectLoading(false);
    });
  };

  /* Handle the click to connect a user to their own account */
  const handleOAuthUserConnectClick = (event) => {
    window.open(userRepository.getOAuthURL(service.id));
  };

  /* Handle the click to connect a user to their agency account */
  const handleOAuthAgencyConnectClick = (event) => {
    // Show the agency modal and specify that loading data has started
    setAgencyIntegrationOAuthModal(true);
    setAgencyIntegrationOAuthLoading(true);

    // Check if this agency has an integration
    agencyIntegrationOAuthRepository
      .getAgencyIntegrationOAuth(agencyId, service.id)
      .then((response) => {
        setAgencyIntegrationOAuthExists(response.exists);
        setAgencyIntegrationOAuth(response);

        // If this agency has an account then proceed to show the accounts
        if (response.exists === true) {
          webAPI
            .getAgencyIntegrationOAuthVoipPhoneNumbers(agencyId, service.id, response.accountId)
            .then((agencyPhoneNumbersResponse) => {
              setAgencyIntegrationOAuthLoading(false);
              setAgencyIntegrationOAuthModal(false);
              setIntegrationAccounts(agencyPhoneNumbersResponse);
            });
        } else {
          setAgencyIntegrationOAuthLoading(false);
        }
      });
  };

  useEffect(() => {
    if (integrationAccounts) {
      if (integrationAccounts.length > 1) {
        setIntegrationAccountModal(true);
      } else {
        var parameters = {
          accountId: integrationAccounts[0].id,
          agencyIntegrationOauth: agencyIntegrationOAuth.id,
        };

        handleAccountSave(parameters).then((oauthResponse) => {
          setUserIntegrationOAuthExists(true);
          setUserIntegrationOAuth(oauthResponse);
        });
      }
    }
  }, [integrationAccounts]);

  // Get integration
  useEffect(() => {
    if (service.type === 'oauth') {
      webAPI
        .getUserIntegrationOAuth(userId, service.id, { include: ['identifier', 'accountId'] })
        .then((response) => {
          setUserIntegrationOAuth(response);
          setUserIntegrationOAuthExists(response.exists === true ? true : false);

          if (response.exists) {
            webAPI
              .validateUserIntegrationOAuth(service.id)
              .then((validationResponse) => { })
              .catch((e) => {
                setUserIntegrationOAuthError(e.message);
              });
          }

          setLoading(false);
        });
    } else if (service.type === 'pat') {
      console.log(service.id);
      userPersonalTokenRepository.getUserPersonalToken(userId, service.id).then((response) => {
        if (service.external === true) {
          if (service.username && service.password) {
            setExternalUsernamePasswordExists(response.exists);
          } else if (service.username && !service.password) {
            setExternalUsernameExists(response.exists);
          }
          setExternalPersonalAccessTokenExists(response.exists);

          if (service.saveWebhookUrls === true) {
            userAppWebhookRepository.getUserAppWebhooks(service.id).then((response) => {
              setIntegrationAppWebhookData(response.getItems());
            });
            setLoading(false);
          } else {
            setLoading(false);
          }
        } else {
          setPersonalAccessTokenExists(response.exists);
          setLoading(false);
        }

        if (!response.exists && service.agencyAccount && agencyId) {
          agencyPersonalTokenRepository
            .getAgencyPersonalToken(agencyId, service.id)
            .then((response) => {
              setAgencyIntegrationPatExists(response.exists);
              setAgencyIntegrationPat(response);
            });
        }
      });
    } else if (service.id === 'simplii') {
      userAppWebhookRepository.getUserAppWebhooks(service.id).then((response) => {
        setIntegrationAppWebhookData(response.getItems());
        setLoading(false);
      });
    } else if (service.type === 'externalOAuthApp') {
      userTokenRepository.getUserAppToken(userId, service.databaseId).then((response) => {
        console.log('token: ', response);
        setExternalOauthAppExists(response.exists);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }

    window.addEventListener('message', (e) => {
      if (e.data && e.data.providerReference === service.id && e.data.payload) {
        setUserIntegrationOAuthError(null);
        setUserIntegrationOAuthPayload(e.data.payload);

        if (e.data.accounts) {
          setIntegrationAccounts(e.data.accounts);
          setIntegrationAccountModal(true);
        } else {
          var parameters = {
            accountId: e.data.accountId,
            identifier: e.data.identifier || null,
            payload: e.data.payload,
          };

          userIntegrationOAuthRepository
            .putUserIntegrationOAuth(
              userId,
              e.data.providerReference,
              { include: ['identifier', 'accountId'] },
              parameters
            )
            .then((oauthResponse) => {
              setUserIntegrationOAuthExists(true);
              setUserIntegrationOAuth(oauthResponse);

              /* Collect Extension and Phone details */
              if (service.syncContacts === true) {
                phoneNumberSelection(e.data.providerReference, parameters.accountId);
              }
            });
        }
      }
    });
  }, []);

  useEffect(() => {
    if (agencyIntegrationPatExists && appAccounts.length === 0) {
      if (service.id == 'textrequest') {
        fetchAppAccounts(agencyIntegrationPat.id);
      }
    }
  }, [agencyIntegrationPatExists]);

  const phoneNumberSelection = (providerReference, accountId) => {
    setIntegrationExtensionNumberModal(true);

    setIntegrationExtensionsLoading(true);

    userVoipExtensionRepository
      .getUserVoipExtensions(userId, service.databaseId, { limit: 100 })
      .then((selectVoIPExtensions) => {
        const selectedExtensions = Array.from(selectVoIPExtensions.getItems(), (extension) =>
          String(extension.getExtensionId())
        );
        console.log(selectedExtensions);
        setIntegrationExtensionsSelected(selectedExtensions);

        webAPI
          .getUserIntegrationOAuthVoipExtensions(userId, providerReference, accountId)
          .then((extensions) => {
            setIntegrationExtensionsLoading(false);
            setIntegrationExtensions(extensions);
          });
      });

    setIntegrationPhoneNumbersLoading(true);

    userVoipPhoneNumberRepository
      .getUserVoipPhoneNumbers(userId, service.databaseId, { limit: 100 })
      .then((selectVoIPPhoneNumber) => {
        const selectedPhoneNumbers = Array.from(selectVoIPPhoneNumber.getItems(), (phoneNumber) =>
          String(phoneNumber.getPhoneNumberId())
        );

        setIntegrationPhoneNumbersSelected(selectedPhoneNumbers);

        webAPI
          .getUserIntegrationOAuthVoipPhoneNumbers(userId, providerReference, accountId)
          .then((phoneNumbers) => {
            setIntegrationPhoneNumbersLoading(false);
            setIntegrationPhoneNumbers(phoneNumbers);
          });
      });
  };

  return (
    service.active && (
      <div className="col-12 px-2 sm-resp mt-3">
        {/* Modal for account selection */}
        <StyledModal
          size="lg"
          title="Select Your Account"
          footerCloseButton={true}
          show={integrationAccountModal}
          onClose={(e) => setIntegrationAccountModal(false)}
        >
          {integrationAccounts && (
            <>
              <p className="alert alert-info small">
                It looks like this account contains multiple users. Please select the correct user
                from the list below.
              </p>
              <select
                className="form-control form-control-sm"
                onChange={(e) => {
                  setIntegrationSelectedAccount(parseInt(e.target.value));
                }}
              >
                <option>Select an account</option>

                {integrationAccounts.map((integrationAccount) => (
                  <option value={integrationAccount.phoneNumberId}>
                    {integrationAccount.phoneNumberName ||
                      Utilities.phoneNumberDisplay(integrationAccount.phoneNumber)}
                  </option>
                ))}
              </select>

              <button
                disabled={integrationSelectedAccount ? false : true}
                onClick={handleAccountSaveClick}
                type="button"
                className="btn btn-sm border border-info btn-info float-right mt-1"
              >
                {integrationCreating ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i> Saving
                  </>
                ) : (
                  <>Save</>
                )}
              </button>
            </>
          )}
        </StyledModal>

        {/* Modal for create personal access token */}
        <StyledModal
          size="lg"
          title="Generate Personal Access Token"
          footerCloseButton={true}
          show={personalAccessTokenCreateModal}
          onClose={(e) => {
            setPersonalAccessTokenCreateModal(false);
            setPersonalAccessTokenNew(null);
          }}
        >
          {personalAccessTokenCreateLoading && (
            <div className="alert small alert-info" role="alert">
              <i className="fas fa-spinner fa-spin ml-2"></i> Loading
            </div>
          )}
          {personalAccessTokenNew && !service.generateIncomingWebhookUrlOnSetup && (
            <>
              <p className="alert alert-success small ">Your access token has been created</p>
              <p className="small calMess">
                You can copy your personal access token below. You need to give this to your{' '}
                {personalAccessTokenNew.getApp().getName()} account manager or use it in the{' '}
                {personalAccessTokenNew.getApp().getName()} self setup area. Store this somewhere
                safe as you won't be able to access this again.
              </p>
              <p className="small">
                <textarea className="form-control form-control-sm border-secondary">
                  {personalAccessTokenNew.getAccessToken()}
                </textarea>
              </p>
            </>
          )}
          {personalAccessTokenNew && service.generateIncomingWebhookUrlOnSetup && (
            <>
              <div class="col-12 mt-3">
                {service.displayIncomingWebhookUrl && (
                  <div class="mb-3 rounded p-3  table-warning">
                    <label class="label">
                      <b>
                        Your Webhook URL (This url will only be visible once. Please copy it and
                        save it)
                      </b>
                    </label>
                    {userWebhookUrlCopied && (
                      <span className={'badge badge-success ml-2'}>
                        URL has been copied to your clipboard
                      </span>
                    )}
                    <div class="row">
                      <div class="col-11">
                        <textarea
                          style={{
                            width: '100%',
                            background: 'none',
                            border: 'none',
                            fontSize: '10pt',
                          }}
                          ref={userWebhookUrlTextAreaRef}
                          value={thisServiceWebhookUrl}
                          className="dataBadge form-control mt-1 text-dark"
                        >
                          {thisServiceWebhookUrl}
                        </textarea>
                      </div>
                      <div class="col-1">
                        <i class="far fa-copy " onClick={handleWebhookUrlCopy}></i>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </StyledModal>

        {/* Modal for edit personal access token */}
        <StyledModal
          size="lg"
          title="Edit Personal Access Token"
          footerCloseButton={true}
          show={personalAccessTokenEditModal}
          onClose={(e) => {
            setPersonalAccessTokenEditModal(false);
            setPersonalAccessTokenNew(null);
          }}
        >
          {personalAccessTokenRevokeLoading && (
            <div className="alert small alert-info" role="alert">
              <i className="fas fa-spinner fa-spin ml-2"></i> Removing your token
            </div>
          )}
          {personalAccessTokenRevoked && !personalAccessTokenRevokeLoading && (
            <p className="alert alert-success small ">Your access token has been revoked</p>
          )}
          {!personalAccessTokenRevoked && !personalAccessTokenRevokeLoading && (
            <>
              <div className="row">
                <div className="col col-8">
                  <p className="small calMess">
                    Refreshing your access token will mean any services using it will cease to
                    function &amp; you will need to reshare the new token to maintain service.
                  </p>
                </div>
                <div className="col col-4 text-right">
                  <button
                    onClick={handlePersonalAccessTokenCreateClick}
                    className="btn  btn-primary mb-4 text-white"
                  >
                    Refresh Token
                  </button>
                </div>

                <div className="col col-8">
                  <p className="small calMess">
                    Revoking your access token will mean any services using it will cease to
                    function.
                  </p>
                </div>
                <div className="col col-4 text-right">
                  <button
                    onClick={handlePersonalAccessTokenRevokeClick}
                    className="btn  btn-danger mb-4 text-white"
                  >
                    Revoke Token
                  </button>
                </div>
              </div>
            </>
          )}
        </StyledModal>

        {/*Modal for create external personal access token */}
        <StyledModal
          size="lg"
          title="Personal Access Token"
          footerCloseButton={true}
          show={externalPersonalAccessTokenCreateModal}
          onClose={(e) => {
            setExternalPersonalAccessTokenCreateModal(false);
          }}
        >
          <>
            {((service.id !== 'slybroadcast' && !service.agencyAccount) ||
              (service.agencyAccount && !agencyId) ||
              (service.agencyAccount && agencyId && singleOverwrite)) && (
                <>
                  <p className="small calMess">
                    Please paste the API token you received from {service.name}.
                  </p>
                  <p className="small">
                    <textarea
                      className="form-control form-control-sm border-secondary"
                      onChange={handleExternalPersonalAccessTokenNew}
                    >
                      {externalPersonalAccessToken}
                    </textarea>
                  </p>
                </>
              )}
            {service.id === 'slybroadcast' && (
              <>
                <p className="small calMess">Please enter your SlyBroadcast phone number.</p>
                <p className="small">
                  <textarea
                    className="form-control form-control-sm border-secondary"
                    onChange={handleExternalPersonalAccessTokenNew}
                  >
                    {externalPersonalAccessToken}
                  </textarea>
                </p>
              </>
            )}
            {service.agencyAccount && agencyId && !singleOverwrite && (
              <>
                <div className="alert alert-primary small">
                  <i className="far fa-info-circle mr-2"></i>Your agency manages your {service.name}{' '}
                  connection.
                </div>
                {service.id == 'healthsherpamedicare' && (
                  <div className="alert alert-info small">
                    <i className="far fa-info-circle mr-2"></i>If you have your own agency version
                    of HealthSherpa for Medicare and your agency in MedicarePro won't be managing
                    your connection click{' '}
                    <a href="#" onClick={() => setSingleOverwrite(true)}>
                      here
                    </a>
                  </div>
                )}
              </>
            )}

            {service.id === 'simpletexting' && (
              <p>
                <small>
                  <b>
                    By default, all phone numbers registered under your {service.name} account will
                    trigger webhook responses to your CRM.{' '}
                  </b>
                  If you’d like to restrict webhooks to a single phone number, please enter it
                  below. Leave this field blank to allow all numbers to trigger webhooks.{' '}
                </small>
                <input
                  type="text"
                  className="form-control form-control-sm mt-2 w-50"
                  placeholder="Enter 10-digit number (e.g. 8881239874)"
                  onChange={(e) => setSimpleTextingPhoneNumber(e.target.value)}
                  value={simpleTextingPhoneNumber}
                />
              </p>
            )}

            {service.id === 'textrequest' && appAccounts.length > 0 && (
              <>
                <p>
                  <small>Please select your account</small>
                </p>
                <select
                  className="form-control form-control-sm mb-3"
                  onChange={(e) => setExternalPersonalAccessAccountId(e.target.value)}
                >
                  <option>Select account...</option>
                  {appAccounts.map((item) => {
                    return <option value={item.id}>{item.name}</option>;
                  })}
                </select>
              </>
            )}
            {service.username && (
              <>
                <div>
                  <small>{service.usernameName || 'Username'}</small>
                </div>
                <input
                  type="text"
                  className="form-control form-control-sm mt-2 w-50 mb-3"
                  onChange={(e) => setExternalPersonalAccessUsername(e.target.value)}
                />
              </>
            )}
            {service.password && (
              <>
                <div>
                  <small>Password</small>
                </div>
                <input
                  type="text"
                  className="form-control form-control-sm mt-2 w-50 mb-3"
                  onChange={(e) => setExternalPersonalAccessPassword(e.target.value)}
                />
              </>
            )}
            {showSave && (
              <p>
                <button
                  class="btn btn-sm btn-primary"
                  disabled={externalPersonalAccessTokenSaving}
                  onClick={handleExternalPersonalAccessTokenSave}
                >
                  Save
                </button>
              </p>
            )}
          </>
        </StyledModal>

        {/*Modal for edit external personal access token */}
        <StyledModal
          size="lg"
          title="Edit Personal Access Token"
          footerCloseButton={true}
          show={externalPersonalAccessTokenEditModal}
          onClose={(e) => {
            setExternalPersonalAccessTokenEditModal(false);
          }}
        >
          {externalPersonalAccessTokenRevokeLoading && (
            <div className="alert small alert-info" role="alert">
              <i className="fas fa-spinner fa-spin ml-2"></i> Removing your token
            </div>
          )}
          {externalPersonalAccessTokenRevoked && !externalPersonalAccessTokenRevokeLoading && (
            <p className="alert alert-success small ">Your access token has been revoked</p>
          )}
          {!externalPersonalAccessTokenRevoked &&
            !externalPersonalAccessTokenRevokeLoading &&
            ((service.agencyAccount && !agencyId) || !service.agencyAccount) && (
              <>
                <div className="row">
                  <div className="col col-8">
                    <p className="small calMess">
                      Adding a new access token will not affect service as long as the token is
                      valid.
                    </p>
                  </div>
                  <div className="col col-4 text-right">
                    <button
                      onClick={handleExternalPersonalAccessTokenCreateClick}
                      className="btn  btn-primary mb-4 text-white"
                    >
                      Refresh Token
                    </button>
                  </div>

                  <div className="col col-8">
                    <p className="small calMess">
                      Revoking your access token will mean MedicarePro will no longer be able to
                      access the service.
                    </p>
                  </div>
                  <div className="col col-4 text-right">
                    <button
                      onClick={handleExternalPersonalAccessTokenRevokeClick}
                      className="btn  btn-danger mb-4 text-white"
                    >
                      Revoke Token
                    </button>
                  </div>
                </div>
              </>
            )}
          {!externalPersonalAccessTokenRevoked &&
            !externalPersonalAccessTokenRevokeLoading &&
            service.agencyAccount &&
            agencyId && (
              <>
                <div className="row">
                  <div className="col col-8">
                    <p className="small calMess">
                      Revoking your setup will mean MedicarePro will no longer be able to access the
                      service.
                    </p>
                  </div>
                  <div className="col col-4 text-right">
                    <button
                      onClick={handleExternalPersonalAccessTokenRevokeClick}
                      className="btn  btn-danger mb-4 text-white"
                    >
                      Revoke
                    </button>
                  </div>
                </div>
              </>
            )}
        </StyledModal>

        {/*Modal for create external connection with username and password */}
        <StyledModal
          size="lg"
          title="Connector"
          footerCloseButton={true}
          show={externalUsernamePasswordCreateModal}
          onClose={(e) => {
            setExternalUsernamePasswordCreateModal(false);
          }}
        >
          <>
            <p className="small calMess">Please enter your {service.name} credentials.</p>
            <label className="label">Username</label>
            <input
              type="text"
              className="form-control form-control-sm mb-2"
              onChange={handleExternalUsernamePasswordUsernameNew}
            ></input>
            <label className="label">Password</label>
            <input
              type="text"
              className="form-control form-control-sm mb-2"
              onChange={handleExternalUsernamePasswordPassNew}
            ></input>
            <label className="label">
              {service.name} {service.accoundIdName}
            </label>
            <input
              type="text"
              className="form-control form-control-sm mb-3"
              onChange={handleExternalUsernamePasswordAccessTokenNew}
            ></input>

            <p>
              <button
                class="btn btn-sm btn-primary"
                disabled={externalUsernamePasswordSaving}
                onClick={handleExternalUsernamePasswordSave}
              >
                Save
              </button>
            </p>
          </>
        </StyledModal>

        {/*Modal for edit external connection with username and password */}
        <StyledModal
          size="lg"
          title="Edit Connector"
          footerCloseButton={true}
          show={externalUsernamePasswordEditModal}
          onClose={(e) => {
            setExternalUsernamePasswordEditModal(false);
            setExternalUsernamePasswordNew(null);
          }}
        >
          {externalUsernamePasswordRevokeLoading && (
            <div className="alert small alert-info" role="alert">
              <i className="fas fa-spinner fa-spin ml-2"></i> Removing your data
            </div>
          )}
          {externalUsernamePasswordRevoked && !externalUsernamePasswordRevokeLoading && (
            <p className="alert alert-success small ">Your connector has been revoked</p>
          )}
          {!externalUsernamePasswordRevoked && !externalUsernamePasswordRevokeLoading && (
            <>
              <div className="row">
                <div className="col col-8">
                  <p className="small calMess">
                    Revoking your access token will mean MedicarePro will no longer be able to
                    access the service.
                  </p>
                </div>
                <div className="col col-4 text-right">
                  <button
                    onClick={handleExternalUsernamePasswordRevokeClick}
                    className="btn  btn-danger mb-4 text-white"
                  >
                    Revoke Token
                  </button>
                </div>
              </div>
            </>
          )}
        </StyledModal>

        {/*Modal for create external connection with username*/}
        <StyledModal
          size="lg"
          title="Connector"
          footerCloseButton={true}
          show={externalUsernameCreateModal}
          onClose={(e) => {
            setExternalUsernameCreateModal(false);
          }}
        >
          <>
            <p className="small calMess">Please enter your {service.name} credentials.</p>
            <label className="label">Username</label>
            <input
              type="text"
              className="form-control form-control-sm mb-2"
              onChange={handleExternalUsernameUsernameNew}
            ></input>

            <p>
              <button
                class="btn btn-sm btn-primary"
                disabled={externalUsernamePasswordSaving}
                onClick={handleExternalUsernameSave}
              >
                Save
              </button>
            </p>
          </>
        </StyledModal>

        {/*Modal for edit external connection with username*/}
        <StyledModal
          size="lg"
          title="Edit Connector"
          footerCloseButton={true}
          show={externalUsernameEditModal}
          onClose={(e) => {
            setExternalUsernameEditModal(false);
            setExternalUsernameNew(null);
          }}
        >
          {externalUsernameRevokeLoading && (
            <div className="alert small alert-info" role="alert">
              <i className="fas fa-spinner fa-spin ml-2"></i> Removing your data
            </div>
          )}
          {externalUsernameRevoked && !externalUsernameRevokeLoading && (
            <p className="alert alert-success small ">Your connector has been revoked</p>
          )}
          {!externalUsernameRevoked && !externalUsernameRevokeLoading && (
            <>
              <div className="row">
                <div className="col col-8">
                  <p className="small calMess">
                    Revoking your access token will mean MedicarePro will no longer be able to
                    access the service.
                  </p>
                </div>
                <div className="col col-4 text-right">
                  <button
                    onClick={handleExternalUsernameRevokeClick}
                    className="btn  btn-danger mb-4 text-white"
                  >
                    Revoke Token
                  </button>
                </div>
              </div>
            </>
          )}
        </StyledModal>

        {/*Modal for adding a App webhook */}

        <StyledModal
          size="lg"
          title="Webhook URL"
          footerCloseButton={true}
          show={integrationAppWebhooksModal}
          onClose={(e) => {
            setIntegrationAppWebhooksModal(false);
          }}
        >
          <>
            <label className="label">Give your webhook URL a name</label>
            <input
              type="text"
              class="form-control form-control-sm"
              name="name"
              onChange={handleIntegrationAppWebhookFormDataChange}
            ></input>

            <label className="label mt-2">URL</label>
            <input
              type="text"
              class="form-control form-control-sm"
              name="url"
              onChange={handleIntegrationAppWebhookFormDataChange}
            ></input>

            <p class="mt-3">
              <button
                class="btn btn-sm btn-primary"
                disabled={integrationAppWebhooksSaving}
                onClick={handleIntegrationAppWebhookSave}
              >
                {integrationAppWebhooksSaving && <i class="far fa-spinner fa-spin mr-1"></i>}Save
              </button>
            </p>
          </>
        </StyledModal>

        {/* Modal for sync */}
        {service.syncContacts && (
          <>
            <StyledModal
              size="lg"
              title="Sync Contacts"
              footerCloseButton={true}
              show={integrationSyncModal}
              onClose={(e) => setIntegrationSyncModal(false)}
            >
              {integrationSyncComplete ? (
                <>
                  <div className="alert alert-success">Syncing completed!</div>
                  {integrationSyncErrors &&
                    integrationSyncErrors.length > 0 &&
                    integrationSyncErrors.map((error) => (
                      <div className="mt-2 alert alert-danger">
                        Invalid contact details for{' '}
                        <a target="_blank" href={`/agent/profileController/index/${error.indId}`}>
                          individual #{error.indId}
                        </a>
                        .
                      </div>
                    ))}
                </>
              ) : (
                <>
                  {integrationSyncStep1Loading && (
                    <div className="alert small alert-info" role="alert">
                      <i className="fas fa-spinner fa-spin ml-2"></i> Loading
                    </div>
                  )}
                  {!integrationSyncStep1Loading && integrationSyncAvailable === 0 && (
                    <div className="alert small alert-success" role="alert">
                      <i className="fal fa-thumbs-up mr-2"></i>Looks like all of your contacts are
                      synced.
                    </div>
                  )}
                  {integrationSyncAvailable !== null && integrationSyncAvailable > 0 && (
                    <>
                      {service.id == 'phonecom' && (
                        <div className="alert alert-info syncInfo">
                          {service.name} allows you to add address book contacts for an account
                          extension. Please select the extension to add contacts to.
                        </div>
                      )}

                      {integrationSyncStep2Loading && (
                        <div className="alert small alert-info" role="alert">
                          <i className="fas fa-spinner fa-spin ml-2"></i> Loading
                        </div>
                      )}
                      {!integrationSyncStep2Loading && (
                        <>
                          <div className="row gutter-2 syncExtensionOption p-2">
                            <div className="col-12 mb-2">
                              <label className="label">Select Profile Type</label>
                              <select
                                className="form-control form-control-sm"
                                onChange={handleSyncProfileTypeChange}
                              >
                                <option>Select...</option>
                                {profileSyncTypeOptions.map((item) => {
                                  return (
                                    <option selected={syncProfileTypeSelected === item}>
                                      {item}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            {service.id == 'phonecom' && (
                              <div className="col-12">
                                <label className="label">Select Extension</label>
                              </div>
                            )}

                            {integrationSyncExtensions &&
                              integrationSyncExtensions.getItems().map((extension) => {
                                return (
                                  <div
                                    onClick={(e) => {
                                      toggleIntegrationSyncExtension(extension.getExtensionId());
                                      setIntegrationSyncDisabled(false);
                                    }}
                                    className={`mx-2 badge border border-success cp phoneTrig calMess ${integrationSyncExtensionSelected === extension.getExtensionId() ? 'bg-success' : ''}`}
                                  >
                                    <b>
                                      {extension.getExtensionNumber()}{' '}
                                      {extension.getExtensionName()
                                        ? ' -' + extension.extensionName
                                        : ''}
                                    </b>
                                  </div>
                                );
                              })}
                            {integrationSyncGroups && (
                              <>
                                <div className="col-12 mt-2">
                                  <label className="label">Select Group</label>
                                </div>
                                <select
                                  className="form-control form-control-sm ml-2"
                                  onChange={toggleIntegrationSyncGroup}
                                >
                                  <option value="">None</option>
                                  {integrationSyncGroups.map((groups) => {
                                    return (
                                      <option
                                        selected={integrationSyncGroupSelected === groups.groupId}
                                        value={groups.groupId}
                                      >
                                        {groups.groupName}
                                      </option>
                                    );
                                  })}
                                </select>
                              </>
                            )}
                          </div>

                          <div className="syncingDataReturn">
                            <div className="col-12 mt-2 calMess">
                              <b>Contacts available for syncing: </b>
                              <span className="totalRecordsSpan">
                                {integrationSyncAvailable || 0}
                              </span>
                            </div>
                            <div className="col-12 mt-2 calMess">
                              <b>Total synced: </b>
                              <span className="totalSyncedSpan">{integrationSyncTotal || 0}</span>
                            </div>
                            <div className="col-12 mt-2 syncAlert d-none">
                              <div className="alert alert-danger">
                                Please do not refresh or leave this page until syncing has
                                completed.
                              </div>
                            </div>
                          </div>
                          <button
                            className="col-12 mt-2 btn btn-info"
                            // disabled={integrationSyncStep3Loading || !integrationSyncExtensionSelected}
                            disabled={integrationSyncDisabled}
                            onClick={handleStartSyncClick}
                          >
                            {integrationSyncStep3Loading ? (
                              <>
                                <i className="fas fa-spinner fa-spin ml-2"></i> Syncing
                              </>
                            ) : (
                              <>Sync</>
                            )}
                          </button>
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </StyledModal>
          </>
        )}
        {service.getPhoneNumbersExtensions && (
          <>
            <StyledModal
              size="lg"
              title="Extensions/Phone Numbers"
              footerCloseButton={true}
              show={integrationExtensionNumberModal}
              onClose={(e) => setIntegrationExtensionNumberModal(false)}
            >
              <div className="col-12">
                <label className="label">
                  Please select which extension(s) you would like to use in the CRM.
                </label>
              </div>
              {integrationExtensions ? (
                <>
                  <div className="extensionOptions">
                    {integrationExtensions.map((extension) => {
                      return (
                        <div
                          onClick={(e) => toggleIntegrationExtension(String(extension.extensionId))}
                          className={`mx-2 mb-2 badge border border-success cp calMess ${integrationExtensionsSelected.includes(String(extension.extensionId)) ? 'bg-success' : ''}`}
                        >
                          <b>
                            {extension.extensionNumber}{' '}
                            {extension.extensionName ? '-' + extension.extensionName : ''}
                          </b>
                        </div>
                      );
                    })}
                  </div>

                  <button
                    disabled={
                      integrationExtensionsSelected.length === 0 || integrationExtensionsSaving
                    }
                    type="button"
                    className="col-12 mt-3 btn btn-primary"
                    onClick={handleIntegrationExtensionsSave}
                  >
                    {integrationExtensionsSaving ? (
                      <>
                        <i className="fas fa-spinner fa-spin"></i> Saving
                      </>
                    ) : (
                      <>Save</>
                    )}
                  </button>
                </>
              ) : (
                <p className="alert alert-info small">
                  Loading <i className="fas fa-spinner fa-spin"></i>
                </p>
              )}

              <div className="phoneOptions mt-3">
                <div className="col-12">
                  <label className="label">Select phone numbers to use in the CRM</label>
                </div>
                {integrationPhoneNumbers ? (
                  <>
                    {integrationPhoneNumbers.map((phoneNumber) => (
                      <div
                        onClick={(e) =>
                          toggleIntegrationPhoneNumber(String(phoneNumber.phoneNumberId))
                        }
                        className={`col-12 mx-2 mb-2 btn border border-primary cp ${integrationPhoneNumbersSelected.includes(String(phoneNumber.phoneNumberId)) ? 'bg-success' : ''}`}
                      >
                        {phoneNumber.phoneNumberName !==
                          Utilities.phoneNumberDisplay(phoneNumber.phoneNumber) ? (
                          <>
                            <i className="fal fa-phone-alt mr-2"></i>
                            {phoneNumber.phoneNumberName}
                            <br />
                          </>
                        ) : (
                          <></>
                        )}{' '}
                        {Utilities.phoneNumberDisplay(phoneNumber.phoneNumber)}
                      </div>
                    ))}

                    <button
                      disabled={
                        integrationPhoneNumbersSelected.length === 0 ||
                        integrationPhoneNumbersSaving
                      }
                      type="button"
                      className="col-12 mt-3 btn btn-primary"
                      onClick={handleIntegrationPhoneNumbersSave}
                    >
                      {integrationPhoneNumbersSaving ? (
                        <>
                          <i className="fas fa-spinner fa-spin"></i> Saving
                        </>
                      ) : (
                        <>Save</>
                      )}
                    </button>
                  </>
                ) : (
                  <p className="alert alert-info small">
                    Loading <i className="fas fa-spinner fa-spin"></i>
                  </p>
                )}
              </div>
            </StyledModal>
          </>
        )}

        {
          service.component &&
          <div className={`card cardAddress ${renderedExternal ? 'border border-secondary' : ''}`}>
            <div className="card-header mb-3">
              <span className="proCrdTitleFull">{service.name}</span>
            </div>
            <div className="card-body" id="rxCards">
              <Twilio
                userId={userId}
                userAccessToken={userAccessToken}
                id={service.id}
                name={service.name}
                image={service.image}
                imageHeight={service.imageHeight}
                databaseId={service.databaseId}
                active={service.active}
                type={service.type}
                external={service.external}
                loading={loading}
                htmlInnerSuffix={service.htmlInnerSuffix}
                token={externalPersonalAccessToken}
                accountId={externalPersonalAccessAccountId}
                tokenExists={externalPersonalAccessTokenExists}
                tokenSaving={externalPersonalAccessTokenSaving}
                tokenRevoking={externalPersonalAccessTokenRevokeLoading}
                tokenRevoked={externalPersonalAccessTokenRevoked}
                onToken={setExternalPersonalAccessToken}
                onAccountId={setExternalPersonalAccessAccountId}
                onPATSave={handleExternalPersonalAccessTokenSave}
                onRevoke={handleExternalPersonalAccessTokenRevokeClick}
              >

              </Twilio>
            </div>
          </div>
        }

        {
          !service.component &&

          <div className={`card cardAddress ${renderedExternal ? 'border border-secondary' : ''}`}>
            <div className="card-header mb-3">
              <span className="proCrdTitleFull">{service.name}</span>
            </div>
            <div className="card-body" id="rxCards">
              {service.htmlPrefix && service.htmlPrefix}
              <div className="row px-3">
                <div className="col-lg-6 text-center px-2 sm-resp mt-4">
                  {service.htmlInnerPrefix && service.htmlInnerPrefix}
                  {loading && (
                    <button className="btn  btn-primary mb-4 text-white">
                      <i className="fas fa-spinner fa-spin"></i> Loading
                    </button>
                  )}
                  {!loading && (
                    <>
                      {service.type === 'custom' && <>{service.html && service.html}</>}
                      {service.type === 'externalOAuthApp' && (
                        <>
                          {externalOauthAppExists ? (
                            <>
                              <div className="badge badge-success p-2" style={{ fontSize: '11pt' }}>
                                <i className="far fa-check-circle mr-1"></i>Connected
                              </div>
                              <br></br>
                              <small>Your connection is managed at {service.name}</small>
                            </>
                          ) : (
                            service.html
                          )}
                        </>
                      )}

                      {/* MedicarePro generated PAT */}
                      {service.type === 'pat' && !service.external && (
                        <>
                          {personalAccessTokenExists ? (
                            <>
                              <button className="btn btn-primary mb-4 ml-1 text-white" disabled>
                                Connected
                              </button>
                              <button
                                className="btn btn-primary mb-4 ml-1 text-white"
                                onClick={handlePersonalAccessTokenEditClick}
                              >
                                Edit
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                className="btn btn-primary mb-4 ml-1 text-white"
                                onClick={handlePersonalAccessTokenCreateClick}
                              >
                                Connect
                              </button>
                            </>
                          )}
                        </>
                      )}

                      {/* External PAT*/}
                      {service.type === 'pat' && service.external && (
                        <>
                          {externalPersonalAccessTokenExists ? (
                            <>
                              <button className="btn btn-primary mb-4 ml-1 text-white" disabled>
                                Connected
                              </button>
                              <button
                                className="btn btn-primary mb-4 ml-1 text-white"
                                onClick={handleExternalPersonalAccessTokenEditClick}
                              >
                                Edit
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                className="btn btn-primary mb-4 ml-1 text-white"
                                onClick={handleExternalPersonalAccessTokenCreateClick}
                              >
                                Connect
                              </button>
                            </>
                          )}
                        </>
                      )}

                      {service.type === 'oauth' && (
                        <>
                          {
                            // Checks to see if the user isn't connected in or is connected but has the 'needsReconnection'  flag set to true or is connected with an invalid token
                            !(userIntegrationOAuth && userIntegrationOAuthExists) ||
                              (userIntegrationOAuth &&
                                userIntegrationOAuthExists &&
                                (userIntegrationOAuth.needsReconnection ||
                                  userIntegrationOAuthError)) ? (
                              /* Connect */
                              <>
                                {userIntegrationOAuth &&
                                  (userIntegrationOAuth.needsReconnection ||
                                    userIntegrationOAuthError) && (
                                    <p className="alert alert-warning">
                                      <i className="fal fa-exclamation-circle mr-1"></i>There's an
                                      issue with your account, which requires a reconnection. Or you
                                      can completely disconnect it.
                                      {userIntegrationOAuthError && (
                                        <>
                                          <br />
                                          <br />
                                          The following error occured: {userIntegrationOAuthError}
                                        </>
                                      )}
                                    </p>
                                  )}
                                {/* Connect personal account */}
                                <button
                                  className={
                                    service.customBranding
                                      ? `btn-oauth-${service.id}`
                                      : `btn btn-primary mb-4 text-white`
                                  }
                                  onClick={handleOAuthUserConnectClick}
                                >
                                  {userIntegrationOAuth &&
                                    (userIntegrationOAuthError ||
                                      userIntegrationOAuth.needsReconnection)
                                    ? service.reconnectLabel || 'Reconnect your account'
                                    : service.connectLabel || 'Connect your account'}
                                </button>
                                {(userIntegrationOAuthError ||
                                  (userIntegrationOAuth &&
                                    userIntegrationOAuth.needsReconnection)) && (
                                    <button
                                      disabled={userIntegrationOAuthDisconnectLoading}
                                      onClick={handleOAuthUserDisconnectClick}
                                      className="btn btn-danger mb-4 ml-2 text-white"
                                    >
                                      {userIntegrationOAuthDisconnectLoading ? (
                                        <>
                                          <i className="fas fa-spinner fa-spin"></i> Disconnecting
                                        </>
                                      ) : (
                                        <>Disconnect</>
                                      )}
                                    </button>
                                  )}

                                {
                                  /* Connect to existing agency account */
                                  service.agencyAccount && (
                                    <>
                                      <button
                                        onClick={handleOAuthAgencyConnectClick}
                                        className={
                                          service.customBranding
                                            ? `ml-1 btn-oauth-${service.id}`
                                            : `btn btn-primary mb-4 text-white ml-1`
                                        }
                                      >
                                        {userIntegrationOAuth &&
                                          (userIntegrationOAuthError ||
                                            userIntegrationOAuth.needsReconnection)
                                          ? service.reconnectLabel || 'Reconnect your agency account'
                                          : service.connectLabel || 'Connect your agency account'}
                                      </button>
                                      {(userIntegrationOAuthError ||
                                        (userIntegrationOAuth &&
                                          userIntegrationOAuth.needsReconnection)) && (
                                          <button
                                            disabled={userIntegrationOAuthDisconnectLoading}
                                            onClick={handleOAuthUserDisconnectClick}
                                            className="btn btn-danger mb-4 ml-2 text-white"
                                          >
                                            {userIntegrationOAuthDisconnectLoading ? (
                                              <>
                                                <i className="fas fa-spinner fa-spin"></i> Disconnecting
                                              </>
                                            ) : (
                                              <>Disconnect</>
                                            )}
                                          </button>
                                        )}
                                    </>
                                  )
                                }

                                {agencyIntegrationOAuthModal && (
                                  <StyledModal
                                    size="lg"
                                    title="Connect Your Agency Account"
                                    footerCloseButton={true}
                                    show={true}
                                    onClose={(e) => setAgencyIntegrationOAuthModal(null)}
                                  >
                                    {agencyIntegrationOAuthLoading ? (
                                      <p className="alert alert-info small">
                                        Getting things ready.{' '}
                                        <i className="fas fa-spinner fa-spin"></i>
                                      </p>
                                    ) : (
                                      !agencyIntegrationOAuthExists && (
                                        <p className="alert alert-warning small ">
                                          Your agency doesn't have an account setup for this provider.
                                          Please get in touch with your agency contact to get this set
                                          up.
                                        </p>
                                      )
                                    )}
                                  </StyledModal>
                                )}
                              </>
                            ) : (
                              /* Disconnect */
                              <>
                                <button className="btn btn-primary mb-4 ml-1 text-white" disabled>
                                  Connected
                                </button>

                                <button
                                  disabled={userIntegrationOAuthDisconnectLoading}
                                  onClick={handleOAuthUserDisconnectClick}
                                  className="btn btn-danger mb-4 ml-1 text-white"
                                >
                                  {userIntegrationOAuthDisconnectLoading ? (
                                    <>
                                      <i className="fas fa-spinner fa-spin"></i> Disconnecting
                                    </>
                                  ) : (
                                    <>Disconnect</>
                                  )}
                                </button>
                                <p className="mt-3">
                                  <strong>{userIntegrationOAuth?.accountId ?? ''}</strong> |{' '}
                                  <strong>{userIntegrationOAuth?.identifier ?? ''}</strong>
                                </p>
                                {service.getPhoneNumbersExtensions === true && (
                                  <>
                                    <button
                                      className="btn btn-success mb-4 text-white"
                                      onClick={(e) => {
                                        phoneNumberSelection(
                                          service.id,
                                          userIntegrationOAuth.agencyAccountId ||
                                          userIntegrationOAuth.accountId
                                        );
                                      }}
                                    >
                                      Edit Extensions & Phone Numbers
                                    </button>
                                  </>
                                )}
                                {service.syncContacts === true && (
                                  <>
                                    <button
                                      className="btn btn-success mb-4 ml-1 text-white"
                                      onClick={handleOAuthUserSyncClick}
                                    >
                                      Sync Contacts
                                    </button>
                                  </>
                                )}
                              </>
                            )
                          }
                        </>
                      )}
                    </>
                  )}
                  {service.htmlInnerSuffix && service.htmlInnerSuffix}
                </div>
                <div className="col-lg-6  text-center px-2   sm-resp mt-4">
                  {service.image && (
                    <img
                      className="rounded"
                      height={service.imageHeight}
                      src={'/public/img/site/' + service.image}
                    />
                  )}
                </div>
                {service.saveWebhookUrls && (
                  <div class="col-12 mt-3">
                    {service.displayIncomingWebhookUrl && (
                      <div class="mb-3 rounded p-3  table-warning">
                        <label class="label">
                          <b>Your Webhook URL</b>
                        </label>
                        {userWebhookUrlCopied && (
                          <span className={'badge badge-success ml-2'}>
                            URL has been copied to your clipboard
                          </span>
                        )}
                        <div class="row">
                          <div class="col-11">
                            <textarea
                              style={{
                                width: '100%',
                                background: 'none',
                                border: 'none',
                                fontSize: '10pt',
                              }}
                              ref={userWebhookUrlTextAreaRef}
                              value={userMarxWebhookUrl}
                              className="dataBadge form-control mt-1 text-dark"
                            >
                              {userMarxWebhookUrl}
                            </textarea>
                          </div>
                          <div class="col-1">
                            <i class="far fa-copy " onClick={handleWebhookUrlCopy}></i>
                          </div>
                        </div>
                      </div>
                    )}

                    <div onClick={handleIntegrationAppWebhookAddClick} class="btn btn-info btn-sm cp">
                      <i class="far fa-plus-circle"></i> Add Webhook URL
                    </div>

                    {integrationAppWebhookData &&
                      integrationAppWebhookData.length > 0 &&
                      integrationAppWebhookData.map((appWebhook, appWebhookIndex) => (
                        <div class="mt-2 rounded p-2 border border-info text-info">
                          <label class="label">
                            <b>{appWebhook.getName()}</b>
                          </label>
                          <div style={{ fontSize: '10pt' }} class="dataBadge">
                            {appWebhook.getUrl()}
                          </div>
                          <div>
                            {integrationAppWebhooksDeleting === appWebhook.getId() && (
                              <i class="far fa-spinner fa-spin text-danger"></i>
                            )}
                            {integrationAppWebhooksDeleting !== appWebhook.getId() && (
                              <i
                                class="far fa-trash text-danger"
                                onClick={() =>
                                  handleIntegrationAppWebhookDeleteClick(appWebhookIndex)
                                }
                              ></i>
                            )}
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </div>
              {service.htmlSuffix && service.htmlSuffix}
            </div>
          </div>
        }
      </div>
    )
  );
}
